<div class="ganancias-container">
  <div class="ganancias-header">
    <h1 class="title">Ganancias</h1>
  </div>

  <div class="ganancias-content">
    <!-- Panel Izquierdo: Resumen Mensual -->
    <div class="monthly-summary-card">
      <div class="card-header">
        <button class="nav-button" (click)="previousMonth()" type="button">
          <i class="fas fa-angle-left"></i>
        </button>
        <h2 class="month-title">{{ getCurrentMonthName() }}</h2>
        <button class="nav-button" (click)="nextMonth()" type="button">
          <i class="fas fa-angle-right"></i>
        </button>
      </div>

      <div class="chart-container">
        <div class="circular-chart">
          <svg class="chart-svg" viewBox="0 0 294 295">
            <!-- Fondo del círculo -->
            <circle
              class="chart-background"
              cx="147"
              cy="147"
              r="130"
              fill="none"
              stroke="#e5e7eb"
              stroke-width="20"
            ></circle>
            <!-- Progreso del círculo -->
            <circle
              class="chart-progress"
              cx="147"
              cy="147"
              r="130"
              fill="none"
              stroke="#dc2626"
              stroke-width="20"
              [attr.stroke-dasharray]="getCircularProgress()"
              stroke-dashoffset="0"
              transform="rotate(-90 147 147)"
            ></circle>
          </svg>
          <div class="chart-content">
            <div class="chart-number">{{ currentMonthHours }}</div>
            <div class="chart-label">Horas en sesiones</div>
          </div>
        </div>
      </div>

      <div class="financial-details">
        <div class="cost-row">
          <span class="cost-label">Costo por hora</span>
          <span class="cost-value">S/. {{ formatCurrency(costPerHour) }}</span>
        </div>
        <div class="total-row">
          <span class="total-label">Total</span>
          <span class="total-value">S/. {{ formatCurrency(currentMonthTotal) }}</span>
        </div>
      </div>
    </div>

    <!-- Panel Derecho: Historial -->
    <div class="history-panel">
      <h2 class="history-title">Historial</h2>

      <div class="table-container">
        <table class="history-table">
          <thead>
            <tr>
              <th class="sortable">
                Periodo de facturación
                <i class="fas fa-arrow-down"></i>
              </th>
              <th>Numero de horas</th>
              <th>Total</th>
              <th>Ver</th>
              <th>Descargar</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let period of paginatedHistory">
              <td>{{ period.period }}</td>
              <td>{{ period.hours }} horas</td>
              <td>S/ {{ formatCurrency(period.total) }}</td>
              <td>
                <button class="icon-button" (click)="viewDetails(period)" type="button">
                  <i class="fas fa-eye"></i>
                </button>
              </td>
              <td>
                <button class="icon-button" (click)="downloadReport(period)" type="button">
                  <i class="fas fa-download"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="paginatedHistory.length === 0">
              <td colspan="5" class="no-data">No hay datos disponibles</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div class="pagination-container">
        <div class="pagination-controls">
          <button
            class="pagination-button"
            [disabled]="currentPage === 1"
            (click)="changePage(currentPage - 1)"
            type="button"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          
          <div class="page-numbers">
            <button
              *ngFor="let page of getPagesArray()"
              class="page-number"
              [class.active]="page === currentPage"
              [disabled]="page === '...'"
              (click)="onPageClick(page)"
              type="button"
            >
              {{ page }}
            </button>
          </div>

          <button
            class="pagination-button"
            [disabled]="currentPage === totalPages"
            (click)="changePage(currentPage + 1)"
            type="button"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>

        <div class="pagination-info">
          <span>Mostrando {{ pageSize }} de {{ totalResults }} resultados</span>
        </div>

        <div class="page-size-selector">
          <span class="mostrar-label">Mostrar</span>
          <select class="page-size-select" [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Detalles -->
<div class="modal-overlay" *ngIf="showDetailsModal" (click)="closeDetailsModal()">
  <div class="details-modal" (click)="$event.stopPropagation()">
    <!-- Botón cerrar -->
    <button class="close-button" (click)="closeDetailsModal()" type="button" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>
    
    <!-- Header -->
    <div class="modal-header">
      <div class="header-left">
        <div class="logo-box">
          <div class="logo-container">
            <div class="logo-icon"></div>
            <span class="logo-text">Phoenix</span>
          </div>
        </div>
        <h2 class="modal-title">Detalles</h2>
        <div class="company-info">
          <p>R.U.C. N.o 20609872463</p>
          <p>PHOENIX GROUP S.A.C.</p>
          <p>San Isidro, Lima, Perú</p>
        </div>
      </div>
      <div class="header-right">
        <div class="total-label">Total {{ getMonthNameForPeriod(selectedPeriod) }}</div>
        <div class="total-amount" *ngIf="selectedPeriod">
          S/{{ formatCurrency(selectedPeriod.total) }}
        </div>
      </div>
    </div>

    <!-- Contenido Principal -->
    <div class="modal-content-wrapper" *ngIf="selectedPeriod">
      <div class="modal-content-box">
        <!-- Tabla de Desglose -->
        <table class="details-table">
          <thead>
            <tr>
              <th>DESCRIPCIÓN</th>
              <th>COSTO POR HORA</th>
              <th>TOTAL DE HORAS</th>
              <th>TOTAL DE INGRESOS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ingresos {{ getMonthNameForPeriod(selectedPeriod) }}</td>
              <td>S/{{ formatCurrency(costPerHour) }}</td>
              <td>{{ selectedPeriod.hours }} horas</td>
              <td>S/{{ formatCurrency(selectedPeriod.total) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Línea separadora -->
        <div class="table-divider"></div>

        <!-- Resumen -->
        <div class="summary-section">
          <div class="summary-item">
            <span class="summary-label">Costo por hora</span>
            <span class="summary-value">S/{{ formatCurrency(costPerHour) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Total de horas</span>
            <span class="summary-value">{{ selectedPeriod.hours }}</span>
          </div>
          <div class="summary-item summary-total">
            <span class="summary-label">Total de ingresos</span>
            <span class="summary-value">S/{{ formatCurrency(selectedPeriod.total) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="terms-section">
        <h3 class="terms-title">Términos y condiciones</h3>
        <p class="terms-text">
          Este documento es necesario para procesar tu pago. Asegúrate de enviarlo correctamente para recibir tus ganancias a tiempo.
        </p>
      </div>
      <button class="download-button" (click)="downloadModalReport(selectedPeriod!)" type="button">
        Descargar
      </button>
    </div>
  </div>
</div>
